import CardIssuer from "enums/CardIssuer";
import type { PlatformRewardsPool } from "./types";

const ISSUER_LABEL: Record<CardIssuer, string> = {
  [CardIssuer.STRIPE]: "Stripe",
  [CardIssuer.HIGHNOTE]: "Highnote",
  [CardIssuer.CORPAY]: "Corpay",
};

export const poolLabel = (
  pool: Pick<PlatformRewardsPool, "issuer" | "currency" | "name">,
) => {
  const issuer = ISSUER_LABEL[pool.issuer as CardIssuer] ?? pool.issuer;
  const account = `${issuer} ${pool.currency.toUpperCase()}`;
  return pool.name ? `${account} (${pool.name})` : account;
};
